/** @format */

import resultModel from './ResultModel';
import paymentModel from './PaymentModel';
import CartModel from './CartModel';
import HeaderModel from './HeaderModel';
import ContactModel from './ContactModel';
import TopSectionModel from './TopSectionModel';
import TravelSearchModel from './TravelSearchModel';
import TravelsSelectModel from './TravelsSelectModel';
import UserModel from './UserModel';

const storeModel = {
	result: resultModel,
	cart: CartModel,
	header: HeaderModel,
	contact: ContactModel,
	topSection: TopSectionModel,
	travelSearch: TravelSearchModel,
	travelsSelect: TravelsSelectModel,
	payment: paymentModel,
	user: UserModel,
};

export default storeModel;
